<ng-template #skeletonTmpl>
  <skeleton-form></skeleton-form>
</ng-template>

<mat-card appearance="outlined" id="customer-selector-dialog" class="mat-typography">
  <mat-toolbar>
    <div class="breadcrumbs">
      <span>Select Account</span>
    </div>
    <span class="spacer"></span>
    <search-box (searchChanges)="searchValue$.next($event)"></search-box>
  </mat-toolbar>
  <mat-dialog-content>
    <mat-nav-list>
      <ng-container *ngIf="filteredItems$ | async as items; else skeletonTmpl">
        <mat-list-item *ngFor="let item of items" (click)="selectCustomer(item)">
          <div class="mat-body-2">
            <div class="row-1">
              <span class="column-2" title="{{ item.fullName }}">{{ item.fullName }}</span>
            </div>
          </div>
        </mat-list-item>
      </ng-container>
    </mat-nav-list>
  </mat-dialog-content>
</mat-card>
